import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import VoltageDividerCalculatorCore from '../components/VoltageDividerCalculatorCore';

const VoltageDividerCalculator = () => {
  return (
    <Container className="py-4">
      <Helmet>
        <meta name="description" content="Try our easy to use Voltage Divider Calculator. Enter any three known values and press Calculate to solve for the other." />
      </Helmet>
      <h1 className="mb-4">Ohm's Law - Voltage Divider Calculator</h1>
      
      <VoltageDividerCalculatorCore />
    </Container>
  );
};

export default VoltageDividerCalculator; 